import React, { FC, PropsWithChildren } from "react";
import classes from './card.module.scss'
import { ITutorData } from "../../model/types";
import { DataList } from "../../../../shared/ui/dataList";
import { LabelBadges } from '../../../../shared/ui/labels';
import { useAppSelector } from "../../../../app/store/store";
import { FEATURES, hasFeature } from "../../../my";
import { SanctionSequenceReset } from "../../../../features/sanctionSequenceReset";
import { tutorService } from "../../api/TutorService";
import { formatTutorConversion } from "../../../../shared/lib/helpers/formatTutorLoad";

interface IProps {
    tutor: ITutorData;
    hideFinanceSection?: boolean;
}

export const TutorCard: FC<IProps & PropsWithChildren> = ({tutor, children, hideFinanceSection = false}) => {
    const {my} = useAppSelector(s => s.myReducer)
    const tutorUserId = Number(tutor.user_id ?? tutor.id)
    const canResetSanctionSequence = hasFeature(my, FEATURES.TUTORS.SANCTION_SEQUENCE_RESET, tutorUserId)

    return (
        <section className={classes.card}>
            <DataList
                title="Данные"
                list={([
                    `ID: ${tutor.id}`,
                    `ФИО: ${tutor.full_name}`,
                    tutor.labels?.length ? <LabelBadges labels={tutor.labels} /> : null,
                    `Дата регистрации: ${tutor.created_at}`,
                    `Телефон: ${tutor.phone}`,
                    `Email: ${tutor.email}`,
                    `Стоимость часа: ${tutor.cost_per_hour} ₽`,
                    `Баланс: ${tutor.balance ? `${tutor.balance} ₽` : '—'}`,
                    `План/факт: ${tutor.desired_hours || '—'}/${tutor.actual_hours || '0'}`,
                    formatTutorConversion(tutor.conversion, tutor.conversion_base, tutor.conversion_closed_count, tutor.conversion_lost_count),
                    <SanctionSequenceReset
                        value={tutor.sanction_sequence_number}
                        canEdit={canResetSanctionSequence}
                        onUpdate={(value) => tutorService.updateSanctionSequence(tutorUserId, value)}
                    />,
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={tutor.tg}
                        className={classes.highlight}
                    >
                        Написать в тг
                    </a>,
                    tutor.tag_ids?.length ? `Теги: ${tutor.tag_ids.join(', ')}` : null,
                    tutor.is_archive
                        ? <span className={classes.archiveStatus}>Статус: <span>В архиве</span></span>
                        : null,
                    tutor.is_archive && tutor.archive_comment.trim()
                        ? <span className={classes.archiveComment}>
                            Причина архивации: {tutor.archive_comment}
                        </span>
                        : null,
                ] as (string | React.ReactNode)[]).filter(item => item !== null)}
            />
            {hideFinanceSection && <section className={classes.workTgColumn}>
                <section className={classes.workTgTitle}>Рабочий ТГ-аккаунт</section>
                <section className={tutor.work_tg_name ? classes.workTgValue : classes.workTgEmpty}>
                    {tutor.work_tg_name || 'Не назначен'}
                </section>
            </section>}
            {
                !hideFinanceSection &&
                <>
                    <section className={classes.finance}>
                        <DataList 
                            title="Финансы"
                            list={[
                                children
                            ]}
                        />
                    </section>
                    <section className={classes.financeMobile}>
                        <section className={classes.title}>Финансы</section>
                        {children}
                    </section>
                </>
            }
        </section>
    )
}
